/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SourceSurveyEnum,
    SourceSurveyEnumFromJSON,
    SourceSurveyEnumFromJSONTyped,
    SourceSurveyEnumToJSON,
} from './SourceSurveyEnum';

/**
 * 
 * @export
 * @interface SourceSurveyDto
 */
export interface SourceSurveyDto {
    /**
     * 
     * @type {SourceSurveyEnum}
     * @memberof SourceSurveyDto
     */
    sourceSurvey: SourceSurveyEnum | null;
}

export function SourceSurveyDtoFromJSON(json: any): SourceSurveyDto {
    return SourceSurveyDtoFromJSONTyped(json, false);
}

export function SourceSurveyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceSurveyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceSurvey': SourceSurveyEnumFromJSON(json['sourceSurvey']),
    };
}

export function SourceSurveyDtoToJSON(value?: SourceSurveyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sourceSurvey': SourceSurveyEnumToJSON(value.sourceSurvey),
    };
}

